import React from 'react';
import { Reveal } from './ui/Reveal';
import { CheckCircle2 } from 'lucide-react';
const bonuses = [{
  title: '58 Recetas Saludables',
  desc: 'Platos deliciosos, fáciles de preparar y diseñados para nutrirte sin complicaciones.'
}, {
  title: '30 Desayunos Saludables',
  desc: 'Empieza tu día con energía. Opciones rápidas para que nunca te saltes la comida más importante.'
}, {
  title: 'Actualizaciones Libres',
  desc: 'Acceso de por vida a las nuevas versiones del programa y material adicional que se agregue.'
}, {
  title: 'Comunidad Exclusiva',
  desc: 'No estás sola. Únete a un grupo de mujeres con tus mismos objetivos para apoyarse mutuamente.'
}];
export function BonusesIncluded() {
  return <section className="py-24 bg-brand-forest text-white overflow-hidden" data-id="element-44">
      <div className="max-w-6xl mx-auto px-6" data-id="element-45">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-46">
          <div data-id="element-47">
            <Reveal data-id="element-48">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-49">
                Todo lo que necesitas para tener éxito
              </h2>
              <p className="text-brand-sage text-lg mb-10" data-id="element-50">
                Al acceder hoy a los 24 Pasos, te llevas completamente GRATIS
                este paquete de herramientas complementarias.
              </p>
            </Reveal>

            <div className="space-y-6" data-id="element-51">
              {bonuses.map((bonus, index) => <Reveal key={index} delay={index * 0.1} data-id="element-52">
                  <div className="flex gap-4" data-id="element-53">
                    <CheckCircle2 className="w-6 h-6 text-brand-coral flex-shrink-0 mt-1" data-id="element-54" />
                    <div data-id="element-55">
                      <h4 className="text-xl font-bold mb-1" data-id="element-56">{bonus.title}</h4>
                      <p className="text-gray-300 text-sm leading-relaxed" data-id="element-57">
                        {bonus.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>)}
            </div>
          </div>

          <Reveal delay={0.3} className="relative" data-id="element-58">
            <div className="absolute inset-0 bg-brand-sage/10 rounded-full blur-3xl -z-10" data-id="element-59" />
            <img src="https://cdn.magicpatterns.com/uploads/vdc5d7EumXkX8FVjuUYyEa/24-PasosATuPesoIdeal_400x210.jpg" alt="Bonos incluidos" className="w-full rounded-2xl shadow-2xl" data-id="element-60" />
          </Reveal>
        </div>
      </div>
    </section>;
}